"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreService = void 0;
const api_1 = require("./api");
const CATALOG_PATH = '/catalog/api/v1';
const ORDER_PATH = '/order/api/v1';
class StoreService {
    static async getStoreCatalog() {
        try {
            return await api_1.API.get({
                url: `${CATALOG_PATH}/items`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async submitOrder(order) {
        try {
            return await api_1.API.post({
                url: `${ORDER_PATH}/orders/submit`,
                body: order
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getThresholdStatus(amount) {
        try {
            return await api_1.API.get({
                url: `${ORDER_PATH}/orders/limit?amount=${amount}`
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.StoreService = StoreService;
//# sourceMappingURL=store-service.js.map